import { ColorModeScript, extendTheme, useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLocalStorage } from "../../hooks";
import { AppConfigContext } from "./AppConfigContext";

const config = {
  initialColorMode: "light",
};
const theme = extendTheme({ config });

/**
 * TODO document this - purpose?? which sidebar??
 */
function AppConfigProvider({ children }) {
  const location = useLocation();

  // Save sidebar state to local storage to persist data on page reload
  const [storedSidebarState, setStoredSidebarState] = useLocalStorage("esgSidebarToggled", true);

  const sidebarToggled = useBreakpointValue({
    base: false,
    lg: storedSidebarState,
  });

  const [sidebarState, setSidebarState] = useState(sidebarToggled);

  const toggleSidebarOnLocation = useBreakpointValue({
    base: (v) => setSidebarState(v),
    lg: () => {},
  });

  useEffect(() => {
    //close sidebar on location change (only for tablet and mobile devices)
    toggleSidebarOnLocation(false);
  }, [location]); //eslint-disable-line

  const toggleSidebar = useBreakpointValue({
    base: (v) => {
      setSidebarState((prev) => v || !prev);
    },
    lg: (v) => {
      setStoredSidebarState((prev) => v || !prev);
      setSidebarState((prev) => v || !prev);
    },
  });

  return (
    <AppConfigContext.Provider
      value={{
        storedSidebarState,
        setStoredSidebarState,
        sidebarState,
        setSidebarState,
        toggleSidebar,
      }}
    >
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      {children}
    </AppConfigContext.Provider>
  );
}

export default AppConfigProvider;
